import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AdminSteps from '../common/AdminSteps';
import { Row, Col, Table } from 'react-bootstrap';
import * as studentsActions from '../../actions/studentsActionCreators';
import * as runActions from '../../actions/runsActionCreators';
import Spinner from 'react-spinkit';
import * as request from '../../utils/request';
import CustomPagination from '../common/CustomPagination';
import { browserHistory } from 'react-router';
import config from '../../config';
import { delay } from 'lodash';
import toastr from 'toastr';


class StudentsPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      studentsLoaded: false,
      students: [],
      startStudents: 0,
      endStudents: config.tableRowsNum,
      activeStudentsPage: 1,
      email: {
        up: false,
        down: false,
        idle: true
      },
      identifier: {
        up: false,
        down: false,
        idle: true
      },
      base_budget: {
        up: false,
        down: false,
        idle: true
      },
      effective_budget: {
        up: false,
        down: false,
        idle: true
      },
      target_course_units: {
        up: false,
        down: false,
        idle: true
      },
      preferences: {
        up: false,
        down: false,
        idle: true
      },
      assigned_credits: {
        up: false,
        down: false,
        idle: true
      },
      pending_request_count: {
        up: false,
        down: false,
        idle: true
      }
    };

    this.handleStudentSearch = this.handleStudentSearch.bind(this);
    this.searchStudents = this.searchStudents.bind(this);
    this.setStudentsToState = this.setStudentsToState.bind(this);
    this.pageBack = this.pageBack.bind(this);
    this.pageForward = this.pageForward.bind(this);

    this.reorder = this.reorder.bind(this);
    this.sortByKeyAndDirection = this.sortByKeyAndDirection.bind(this);
    this.checkKey = this.checkKey.bind(this);
  }
  componentWillMount() {
    if (!this.props.run.id) {
      this.props.runActions.getRun();
    }
    if (this.props.students.length < 1) {
      this.props.studentsActions.getAllStudents().then(() => {
        this.setState({ studentsLoaded: true });
      });
    } else {
      this.setState({ studentsLoaded: true });
    }
    this.setStudentsToState(this.props.students);
    document.onkeydown = this.checkKey;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.students != this.props.students) {
      this.setStudentsToState(nextProps.students);
      this.setState({ studentsLoaded: true });
    }
  }

  checkKey(e) {
    if (this.refs.students) {
      e = e || window.event;
      if (e.keyCode == '37') {
        // left arrow
        if (this.state.activeStudentsPage > 1) {
          this.pageBack();
        }
      } else if (e.keyCode == '39') {
        // right arrow
        if (this.state.activeStudentsPage < Math.ceil(this.state.students.length / config.tableRowsNum)) {
          this.pageForward();
        }
      }
    }
  }

  handleStudentSearch(e) {
    e.preventDefault();
    let term = e.target.value;
    if (term != '') {
      let arrUnique = this.searchStudents(term, this.props.students);

      this.setState({
        students: arrUnique,
        startStudents: 0,
        endStudents: config.tableRowsNum,
        activeStudentsPage: 1
      });
    } else {
      // this.props.courseActions.getAllCourses();
      this.setStudentsToState(this.props.students);
    }
  }

  searchStudents(term, students) {
    let b = students.filter(student => {
      return (
        student.user.email.toLowerCase().indexOf(term.toLowerCase()) != -1 ||
        student.identifier.toLowerCase().indexOf(term.toLowerCase()) != -1
      );
    });
    return b;
  }

  setStudentsToState(students) {
    this.setState({ students: students });
  }

  pageBack() {
    let newActivePage = this.state.activeStudentsPage - 1;
    this.setState({ activeStudentsPage: newActivePage });
    if (newActivePage == 1) {
      this.setState({ startStudents: 0, endStudents: config.tableRowsNum });
    } else {
      let start = newActivePage * config.tableRowsNum - config.tableRowsNum;
      let end = newActivePage * config.tableRowsNum;
      this.setState({ startStudents: start, endStudents: end });
    }
  }
  pageForward() {
    let newActivePage = this.state.activeStudentsPage + 1;
    this.setState({ activeStudentsPage: newActivePage });
    let start = newActivePage * config.tableRowsNum - config.tableRowsNum;
    let end = newActivePage * config.tableRowsNum;
    this.setState({ startStudents: start, endStudents: end });
  }

  // Ordering
  reorder = column => () => {
    if (this.state[column].idle) {
      this.setState({
        [column]: {
          up: true,
          down: false,
          idle: false
        }
      });
      let a = this.sortByKeyAndDirection(this.state.students, column, 'up');
      this.setState({ students: a });
    } else if (this.state[column].up) {
      this.setState({
        [column]: {
          up: false,
          down: true,
          idle: false
        }
      });
      let a = this.sortByKeyAndDirection(this.state.students, column, 'down');
      this.setState({ students: a });
    } else if (this.state[column].down) {
      this.setState({
        [column]: {
          up: true,
          down: false,
          idle: false
        }
      });
      let a = this.sortByKeyAndDirection(this.state.students, column, 'up');
      this.setState({ students: a });
    }
    let obj = {
      email: {
        up: false,
        down: false,
        idle: true
      },
      identifier: {
        up: false,
        down: false,
        idle: true
      },
      base_budget: {
        up: false,
        down: false,
        idle: true
      },
      effective_budget: {
        up: false,
        down: false,
        idle: true
      },
      target_course_units: {
        up: false,
        down: false,
        idle: true
      },
      preferences: {
        up: false,
        down: false,
        idle: true
      },
      assigned_credits: {
        up: false,
        down: false,
        idle: true
      },
      pending_request_count: {
        up: false,
        down: false,
        idle: true
      }
    };

    delete obj[column];
    this.setState(obj);

    // Reset pagination
    this.setState({
      startStudents: 0,
      endStudents: config.tableRowsNum,
      activeStudentsPage: 1
    });
  };

  // Function for sorting array by key and direction ASC/DESC(up/down)
  sortByKeyAndDirection(array, key, direction) {
    if (key != 'email' && key != 'preferences') {
      return array.sort(function(a, b) {
        var x = a[key];
        var y = b[key];
        if (direction == 'up') {
          return x < y ? -1 : x > y ? 1 : 0;
        } else if (direction == 'down') {
          return x > y ? -1 : x < y ? 1 : 0;
        }
      });
    } else if (key == 'email') {
      return array.sort(function(a, b) {
        var x = a.user[key];
        var y = b.user[key];
        if (direction == 'up') {
          return x < y ? -1 : x > y ? 1 : 0;
        } else if (direction == 'down') {
          return x > y ? -1 : x < y ? 1 : 0;
        }
      });
    } else if (key == 'preferences') {
      return array.sort(function(a, b) {
        var x = a.preference_count;
        var y = b.preference_count;
        if (direction == 'up') {
          return x < y ? -1 : x > y ? 1 : 0;
        } else if (direction == 'down') {
          return x > y ? -1 : x < y ? 1 : 0;
        }
      });
    }
  }

  handleEditStudent = student => () => {
    browserHistory.push('/administer/' + localStorage.getItem('run') + '/student/' + student.id);
  };

  addStudent = () => () => {
    browserHistory.push('/administer/' + localStorage.getItem('run') + '/student/');
  };

  checkPublishingStatus = url => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('GET', url)
        .then(response => {
          if (response.data.status === 'success') {
            return resolve(response.data.output);
          } else {
            delay(() => {
              resolve(this.checkPublishingStatus(url));
            }, 1000)
          }
        })
        .catch(error => {
          console.log(error);
          toastr.error('Error while publishing');
          return reject('Error');
        });
    });
    return promise;
  };

  exportList = () => () => {
    console.log('Export list');
    this.setState({ studentsLoaded: false });
    this.props.studentsActions.exportStudentList()
      .then(async data => {
        const finalOutput = await this.checkPublishingStatus(data.url);
        console.log(finalOutput);
        window.location.href = finalOutput;
        this.setState({ studentsLoaded: true });
      })
      .catch(err => console.log(err));
  };

  render() {
    const { assignment_complete } = this.props.run;
    return (
      <Col md={12}>
        <div className="page-title">Manage Students</div>
        <AdminSteps active="2" label={this.props.run.slug} assignment_complete={assignment_complete} />
        <Row>
          <Col md={8}>
            <div className="form-group search">
              <span className="fa fa-search" />
              <input
                name="studentsSearchInput"
                onChange={e => {
                  this.handleStudentSearch(e);
                }}
                type="text"
                className="form-control"
                placeholder="Type email or identifier..."
              />
              <span className="input-description">Type email or identifier to filter students</span>
            </div>
          </Col>
          <Col md={4}>
            <button type="button" className="btn btn-ter mr-5" onClick={this.addStudent()}>
              Add Student
            </button>
            <button type="button" className="btn btn-ter" onClick={this.exportList()}>
              Export List
            </button>
          </Col>
        </Row>

        <Row ref="students" className="height480">
          {this.state.studentsLoaded ? (
            <Col md={12}>
              {this.props.students.length > 0 ? (
                <div className="c-table classes-table">
                  <Table condensed hover>
                    <thead>
                      <tr>
                        <th className="name" onClick={this.reorder('identifier')}>
                          <span>
                            Email address {this.state.email.up ? <i className="fa fa-sort-up" /> : null}
                            {this.state.email.down ? <i className="fa fa-sort-down" /> : null}{' '}
                            {this.state.email.idle ? <i className="fa fa-sort" /> : null}
                          </span>
                        </th>
                        {assignment_complete
                          ? [
                              <th key="assigned_credits" onClick={this.reorder('assigned_credits')}>
                                <span>
                                  Assigned Credits{' '}
                                  {this.state.assigned_credits.up ? <i className="fa fa-sort-up" /> : null}
                                  {this.state.assigned_credits.down ? <i className="fa fa-sort-down" /> : null}{' '}
                                  {this.state.assigned_credits.idle ? <i className="fa fa-sort" /> : null}
                                </span>
                              </th>,
                              <th key="pending_request_count" onClick={this.reorder('pending_request_count')}>
                                <span>
                                  Pending Requests{' '}
                                  {this.state.pending_request_count.up ? <i className="fa fa-sort-up" /> : null}
                                  {this.state.pending_request_count.down ? <i className="fa fa-sort-down" /> : null}{' '}
                                  {this.state.pending_request_count.idle ? <i className="fa fa-sort" /> : null}
                                </span>
                              </th>
                            ]
                          : [
                              <th key="preferences" onClick={this.reorder('preferences')}>
                                <span>
                                  Rankings {this.state.preferences.up ? <i className="fa fa-sort-up" /> : null}
                                  {this.state.preferences.down ? <i className="fa fa-sort-down" /> : null}{' '}
                                  {this.state.preferences.idle ? <i className="fa fa-sort" /> : null}
                                </span>
                              </th>,
                              <th key="target_course_units" onClick={this.reorder('target_course_units')}>
                                <span>
                                  Requested Credits{' '}
                                  {this.state.target_course_units.up ? <i className="fa fa-sort-up" /> : null}
                                  {this.state.target_course_units.down ? <i className="fa fa-sort-down" /> : null}{' '}
                                  {this.state.target_course_units.idle ? <i className="fa fa-sort" /> : null}
                                </span>
                              </th>,
                              <th key="base_budget" onClick={this.reorder('base_budget')}>
                                <span>
                                  Base Budget {this.state.base_budget.up ? <i className="fa fa-sort-up" /> : null}
                                  {this.state.base_budget.down ? <i className="fa fa-sort-down" /> : null}{' '}
                                  {this.state.base_budget.idle ? <i className="fa fa-sort" /> : null}
                                </span>
                              </th>,
                              <th key="effective_budget" onClick={this.reorder('effective_budget')}>
                                <span>
                                  Adjusted Budget{' '}
                                  {this.state.effective_budget.up ? <i className="fa fa-sort-up" /> : null}
                                  {this.state.effective_budget.down ? <i className="fa fa-sort-down" /> : null}{' '}
                                  {this.state.effective_budget.idle ? <i className="fa fa-sort" /> : null}
                                </span>
                              </th>
                            ]}
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.students
                        .slice(this.state.startStudents, this.state.endStudents)
                        .map((student) => {
                          return (
                            <tr key={student.id}>
                              <td className="class-name">
                                <span onClick={this.handleEditStudent(student)}>{student.user.email}</span>
                              </td>
                              {assignment_complete
                                ? [
                                    <td key="assigned_credits" className="class-desc">{student.assigned_credits}</td>,
                                    <td key="pending_request_count" className="class-desc">{student.pending_request_count}</td>
                                  ]
                                : [
                                    <td key="preference_count" className="class-desc">{student.preference_count}</td>,
                                    <td key="target_course_units" className="class-desc">
                                      {student.target_course_units == student.max_course_units ||
                                      student.max_course_units == null
                                        ? student.target_course_units
                                        : `${student.target_course_units}/${student.max_course_units}`}
                                    </td>,
                                    <td key="base_budget" className="class-desc">{student.base_budget / 100}</td>,
                                    <td key="effective_budget" className="class-desc">{student.effective_budget / 100}</td>
                                  ]}

                              <td className="class-edit">
                                <span onClick={this.handleEditStudent(student)}>Edit</span>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </Table>
                  <CustomPagination
                    activePage={this.state.activeStudentsPage}
                    onBack={this.pageBack}
                    onForward={this.pageForward}
                    listLength={Math.ceil(this.state.students.length / config.tableRowsNum)}
                  />
                </div>
              ) : (
                <div className="text-center">No Students</div>
              )}
            </Col>
          ) : (
            <div className="spinner-box">
              <Spinner spinnerName="three-bounce" className="mt-4" />
            </div>
          )}
        </Row>
      </Col>
    );
  }
}

function mapStateToProps(state) {
  return {
    run: state.run,
    students: state.students
  };
}

function mapDispatchToProps(dispatch) {
  return {
    studentsActions: bindActionCreators(studentsActions, dispatch),
    runActions: bindActionCreators(runActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudentsPage);



// WEBPACK FOOTER //
// ./src/components/students/StudentsPage.js